module.exports = __webpack_public_path__ + "img/emv_Bil.b94f85d4.svg";